import React, { useEffect, useRef, useState } from 'react'
import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Typography,
} from '@material-tailwind/react'
import { useNumericMenu } from 'react-instantsearch-hooks-web'
import { cn } from '../../../../Utils/component'
import { PriceRangeSlider } from './PriceRangeSlider'
import {
  composePayRangeValues,
  findPayRangeItem,
} from '../../../../Utils/offers/payRange'
import { buttonClassName } from '../../button/utils'

export const PayRangesSliderModal = ({
  name,
  attribute,
}: {
  name: string
  attribute: string
}) => {
  const max = 200
  const min = 0

  const [payRangeMin, setPayRangeMin] = useState<number>(min)
  const [openBottom, setOpenBottom] = useState(false)

  const possiblesValues = composePayRangeValues({
    min,
    max,
  })

  const { refine: refineMin, items: minItems } = useNumericMenu({
    attribute,
    items: possiblesValues,
  })

  useEffect(() => {
    if (payRangeMin !== min) {
      const minRange = findPayRangeItem({
        nbr: payRangeMin,
        items: minItems,
      })

      if (minRange) {
        refineMin(minRange.value)
      }
    }
  }, [payRangeMin])

  const closeDrawerBottom = () => setOpenBottom(false)
  const handleOpen = () => setOpenBottom(true)

  function useOutsideAlerter(ref: React.RefObject<HTMLDivElement>) {
    useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event?.target)) {
          closeDrawerBottom()
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  return (
    <div id={`refinement-${name}`} className="flex items-end h-12 mr-1">
      <button
        type="button"
        className={cn(
          'relative md:text-lg md:hidden',
          buttonClassName({
            color: 'primary',
            filter: true,
            disabled: false,
            size: 'small',
          }),
        )}
        onClick={() => setOpenBottom(!openBottom)}
      >
        <div className="space-x-2 text-sm">
          <span>{name}</span>
        </div>
      </button>

      <Popover
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0, y: 25 },
        }}
        placement="bottom"
      >
        <PopoverHandler>
          <button
            type="button"
            className={cn(
              'relative md:text-lg hidden md:block',
              buttonClassName({
                color: 'primary',
                filter: true,
                disabled: false,
                size: 'small',
              }),
            )}
            onClick={handleOpen}
          >
            <div className="space-x-2 text-sm">
              <span>{name}</span>
            </div>
          </button>
        </PopoverHandler>

        <PopoverContent className="space-y-4">
          <div className="z-[4] space-y-4 pb-14">
            <div className="relative block m-0">
              <Typography variant="h4" className="text-lg text-night">
                Salaire annuel minimum
              </Typography>
              <Typography className="mt-1 text-base font-normal text-gray-600">
                Attention les offres sans salaire renseigné ne seront pas
                affichées.
              </Typography>
            </div>

            <PriceRangeSlider
              payRangeMin={payRangeMin}
              onChange={(value) => setPayRangeMin(value)}
            />
          </div>
        </PopoverContent>
      </Popover>

      <section
        id={`refinement-${name}`}
        ref={wrapperRef}
        className={cn(
          'p-4 fixed bg-white bottom-0 left-0 right-0 z-20 max-h-[500px] overflow-y-scroll rounded-t-lg animate-enter',
          'md:hidden',
          openBottom ? 'block' : 'hidden',
        )}
      >
        <div className="z-[4] space-y-4 pb-14">
          <div className="relative block m-0">
            <Typography variant="h4" className="text-lg text-night">
              Salaire annuel minimum
            </Typography>
            <Typography className="mt-1 text-base font-normal text-gray-600">
              Attention les offres sans salaire renseigné ne seront pas
              affichées.
            </Typography>
          </div>

          <PriceRangeSlider
            payRangeMin={payRangeMin}
            onChange={(value) => setPayRangeMin(value)}
          />
        </div>
      </section>
    </div>
  )
}
